/**
* @file 旅游包车 - 包车设置（旅游包车：开通城市+套餐管理+提成规则；专线包车：提成规则）
* */
<template>
  <div id="charteredSetting">
    <el-tabs v-model="settingTab" type="card" class="setting-tabs">
      <el-tab-pane name="tourism">
        <span slot="label"><i class="el-icon-truck" style="margin-right:4px"></i>旅游包车</span>
      </el-tab-pane>
      <el-tab-pane name="intercity">
        <span slot="label"><i class="el-icon-s-promotion" style="margin-right:4px"></i>专线包车</span>
      </el-tab-pane>
    </el-tabs>

    <!-- 旅游包车设置 -->
    <div v-show="settingTab === 'tourism'">
    <div class="block">
      <div class="block__left">开通城市</div>
      <div class="block__right">
        <p class="tips" style="margin-bottom: 10px;">添加的城市在小程序包车下单时选择</p>
        <div class="block__right__cityList">
          <el-tag v-for="cityTag in cityTags" :key="cityTag.id" size="medium" closable @close="deleteCity(cityTag)">
            {{ cityTag.city }} </el-tag>
        </div>
        <div class="block__right__cityAdd">
          <el-button type="text" size="medium" @click="cityVisible = true"><i class="el-icon-circle-plus-outline"></i>
            添加城市</el-button>
        </div>
      </div>
    </div>

    <div class="block">
      <div class="block__left">包车套餐</div>
      <div class="block__right">
        <p class="tips">展示给乘客选择</p>
      </div>
    </div>

    <div class="block">
      <div>
        <el-table style="margin-bottom: 20px;width:750px" border empty-text="暂无数据" :data="comboRows">
          <el-table-column label="车型名称" prop="name"></el-table-column>
          <el-table-column label="座位数量" prop="vehicleSeat" width="80" v-slot="{ row }">
            {{ row.vehicleSeat }} 座
          </el-table-column>
          <el-table-column label="基础费用" prop="baseFee" width="80" v-slot="{ row }">
            ￥{{ row.baseFee }}
          </el-table-column>
          <el-table-column label="超时收费" prop="timeFee" width="120" v-slot="{ row }">
            ￥{{ row.timeFee }} / 半小时
          </el-table-column>
          <el-table-column label="超里程费" prop="mileFee" width="120" v-slot="{ row }">
            ￥{{ row.mileFee }} / 公里
          </el-table-column>
          <el-table-column label="车型描述" prop="remark"></el-table-column>
          <el-table-column fixed="right" label="操作" width="100">
            <template v-slot="{ row }">
              <el-button @click="editComboClick(row)" type="text" size="small">编辑</el-button>
              <el-button type="text" size="small" @click="deleteCombo(row.id)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-button style="border: 1px #dcdfe6 dashed;padding: 10px;width: 100%;"
          @click="comboTitle = '创建包车套餐'; comboVisible = true;">
          <i class="el-icon-circle-plus-outline"></i> 添加车型
        </el-button>
      </div>
      <br>
    </div>

    <div class="block">
      <div class="block__left" style="line-height: 28px;">提成规则</div>
      <div class="block__right">
        <el-radio-group v-model="commission.status" :disabled="!commissionEdit">
          <el-radio :label="1">开启</el-radio>
          <el-radio :label="2">关闭</el-radio>
        </el-radio-group>
        <el-input v-model="commission.proportion" :disabled="!commissionEdit" placeholder="请输入要给司机的提成比例"
          style="width:200px;margin:0 20px" oninput="value=value.replace(/^0/g, '')
    	       					  .replace(/(\d\d{0,1}\.?\d{0,2})?.*/g,'$1')
    	       					  .replace(/^[1-9][0-9]{2,}/g,'100')">
          <template #append>%</template>
        </el-input>
        <el-button v-if="!commissionEdit" type="primary" size="mini" @click="commissionEdit = true">编辑</el-button>
        <div v-else style="display:inline-block">
          <el-button type="primary" size="mini" @click="savecommission">保存</el-button>
          <el-button size="mini" @click="getCommission">取消</el-button>
        </div>
      </div>
    </div>
    </div><!-- /旅游包车设置 -->

    <!-- 专线包车设置 -->
    <div v-show="settingTab === 'intercity'">
      <div class="block">
        <div class="block__left" style="line-height: 28px;">提成规则</div>
        <div class="block__right">
          <p class="tips" style="margin-bottom: 10px;">专线包车司机提成规则，支持统一比例或金额阶梯提成</p>
          <el-table :data="intercityCommissionList" border empty-text="暂无数据" size="small" style="width:700px;margin-bottom:12px">
            <el-table-column prop="name" label="规则名称" min-width="120"></el-table-column>
            <el-table-column prop="type" label="提成方式" width="120">
              <template slot-scope="{ row }">
                <el-tag size="mini" :type="row.type === 1 ? 'primary' : 'warning'">
                  {{ row.type === 1 ? '统一比例' : '金额阶梯' }}
                </el-tag>
              </template>
            </el-table-column>
            <el-table-column prop="proportion" label="提成比例" width="100">
              <template slot-scope="{ row }">{{ row.proportion }}%</template>
            </el-table-column>
            <el-table-column prop="status" label="状态" width="80">
              <template slot-scope="{ row }">
                <el-tag size="mini" :type="row.status === 1 ? 'success' : 'info'">
                  {{ row.status === 1 ? '启用' : '禁用' }}
                </el-tag>
              </template>
            </el-table-column>
            <el-table-column fixed="right" label="操作" width="120">
              <template slot-scope="{ row }">
                <el-button type="text" size="small" @click="editIntercityCommission(row)">编辑</el-button>
                <el-button type="text" size="small" @click="deleteIntercityCommission(row.id)">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
          <el-button type="primary" size="small" icon="el-icon-plus" @click="intercityCommissionVisible = true">添加提成规则</el-button>
        </div>
      </div>
    </div><!-- /专线包车设置 -->

    <el-dialog :visible.sync="intercityCommissionVisible" width="30%" title="专线包车提成规则" :close-on-click-modal="false"
      @close="resetIntercityForm">
      <el-form :model="formIntercityCommission" :rules="rulesIntercityCommission" ref="formIntercityCommission" label-width="90px">
        <el-form-item label="规则名称" prop="name">
          <el-input v-model="formIntercityCommission.name" maxlength="20" placeholder="请输入规则名称"></el-input>
        </el-form-item>
        <el-form-item label="提成方式" prop="type">
          <el-radio-group v-model="formIntercityCommission.type">
            <el-radio :label="1">统一比例提成</el-radio>
            <el-radio :label="2">金额阶梯提成</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="提成比例" prop="proportion" v-if="formIntercityCommission.type === 1">
          <el-input v-model="formIntercityCommission.proportion" placeholder="0~100"
            oninput="value=value.replace(/[^\d.]/g,'')">
            <template slot="append">%</template>
          </el-input>
        </el-form-item>
        <el-form-item label="启用状态" prop="status">
          <el-radio-group v-model="formIntercityCommission.status">
            <el-radio :label="1">启用</el-radio>
            <el-radio :label="2">禁用</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="intercityCommissionVisible = false">取消</el-button>
        <el-button type="primary" :loading="loadingIntercity" @click="saveIntercityCommission">保存</el-button>
      </div>
    </el-dialog>

    <el-dialog :visible.sync="cityVisible" @close="checkCity = null" width="20%" title="城市搜索">
      <el-select v-model="checkCity" filterable placeholder="请输入要搜索的城市关键字" style="padding-bottom:20px"
        @change="selectCity">
        <el-option v-for="city in citys" :key="city.cityCode" :label="city.city" :value="city.cityCode">
          <span style="float: left">{{ city.city }}</span>
          <span style="float: right; color: #8492a6; font-size: 13px">{{ city.province }}</span>
        </el-option>
      </el-select>
    </el-dialog>

    <el-dialog :visible.sync="comboVisible" @close="$refs.formCombo.resetFields(); formCombo.id = null;" width="25%"
      :title="comboTitle" :close-on-click-modal="false">
      <el-form :model="formCombo" :rules="rulesCombo" ref="formCombo" label-position="left" label-width="80px">
        <el-form-item label="车型名称" prop="name">
          <el-input v-model="formCombo.name" maxlength="8" placeholder="请输入车型名称">
          </el-input>
          <p class="tips">展示给用户看的车型名称</p>
        </el-form-item>
        <el-form-item label="车型描述" prop="remark">
          <el-input v-model="formCombo.remark" maxlength="30" type="textarea" placeholder="建议输入车辆品牌、舒适度、可存放的行李尺寸等">
          </el-input>
        </el-form-item>
        <el-form-item label="座位数量" prop="vehicleSeat">
          <el-select v-model="formCombo.vehicleSeat" filterable>
            <el-option v-for="item in $const.SEATNUMBER" :label="item.label" :key="item.value"
              :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="基础费用" prop="baseFee">
          <el-input v-model="formCombo.baseFee" maxlength="64" placeholder="请输入基础费用"
            oninput="value=value.replace(/[^\d]/g, '')">
            <template slot="append">元</template>
          </el-input>
          <p class="tips">每日基础费用，含每日100公里/8小时</p>
        </el-form-item>
        <el-form-item label="超时收费" prop="timeFee">
          <el-input v-model="formCombo.timeFee" maxlength="64" placeholder="请输入超时长费"
            oninput="value=value.replace(/[^\d]/g, '')">
            <template slot="append">元/半小时</template>
          </el-input>
          <p class="tips">半小时为最小计量单位，超过5分钟按半小时计算/8小时</p>
        </el-form-item>
        <el-form-item label="超里程费" prop="mileFee">
          <el-input v-model="formCombo.mileFee" maxlength="64" placeholder="请输入超里程费"
            oninput="value=value.replace(/[^\d]/g, '')">
            <template slot="append">元/公里</template>
          </el-input>
          <p class="tips">超出部分不足1公里按1公里计算</p>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer" style="text-align: center; padding-top: 0; position: relative; top: -15px;">
        <el-button type="primary" :loading="loadingCombo" @click="saveCombo" style="width:100%">
          保存
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import provinceCitys from "../../../public/provinceCitys";

export default {
  name: "charteredSetting",
  data() {
    return {
      settingTab: 'tourism',
      cityVisible: false,
      citys: [],
      checkCity: null,
      cityTags: [],
      comboRows: [],
      comboVisible: false,
      comboTitle: null,
      formCombo: {
        name: null,
        remark: null,
        vehicleSeat: null,
        baseFee: null,
        timeFee: null,
        mileFee: null,
      },
      rulesCombo: {
        name: [{ required: true, message: "请输入车型名称" }],
        remark: [{ required: true, message: "请输入车型描述" }],
        vehicleSeat: [{ required: true, message: "请选择座位数量" }],
        baseFee: [{ required: true, message: "请输入基础费用" }],
        timeFee: [{ required: true, message: "请输入超时收费" }],
        mileFee: [{ required: true, message: "请输入超里程费" }],
      },
      loadingCombo: false,
      commissionEdit: false,
      commission: {
        status: 1,
        proportion: null,
      },
      intercityCommissionList: [],
      intercityCommissionVisible: false,
      loadingIntercity: false,
      formIntercityCommission: {
        id: null,
        name: null,
        type: 1,
        proportion: null,
        status: 1,
      },
      rulesIntercityCommission: {
        name: [{ required: true, message: "请输入规则名称" }],
        type: [{ required: true, message: "请选择提成方式" }],
        status: [{ required: true, message: "请选择状态" }],
      },
    };
  },
  created() {
    this.getCheckCityList();
    this.getComboList();
    this.getCommission();
    this.getCity();
    this.getIntercityCommissionList();
  },
  methods: {
    async getCheckCityList() {
      let data = await this.$axios.get("/api/v1/manage/chartered/city", { organizationId: this.mixinUserInfo.organizationId });
      if (data && data.code === 1) {
        this.cityTags = data.data;
      }
    },
    getCity() {
      let zhixia = ['北京市', '上海市', '重庆市', '天津市']
      let iteration = (list) => {
        let cityList = [];
        list.map(province => {
          if (zhixia.includes(province.label)) {
            cityList.push({ province: province.label, city: province.label, cityCode: province.value })
          } else {
            province.children.map(city => {
              cityList.push({ province: province.label, city: city.label, cityCode: city.value })
            })
          }
        })
        return cityList;
      }
      this.citys = iteration(provinceCitys[0])
    },
    async selectCity(city) {
      city = this.citys.find(item => item.cityCode == city)
      let data = await this.$axios.post("/api/v1/manage/chartered/city", { ...city, organizationId: this.mixinUserInfo.organizationId });
      if (data && data.code === 1) {
        this.$message.success('已添加')
        this.getCheckCityList();
      }
      this.checkCity = null;
      this.cityVisible = false;
    },
    async deleteCity(city) {
      let data = await this.$axios.delete("/api/v1/manage/chartered/city", { id: city.id });
      if (data && data.code === 1) {
        this.$message.success('已删除')
        this.getCheckCityList();
      }
    },
    async getComboList() {
      let data = await this.$axios.get("/api/v1/manage/chartered", { organizationId: this.mixinUserInfo.organizationId });
      if (data && data.code === 1) {
        this.comboRows = data.data;
      }
    },
    async saveCombo() {
      this.$refs.formCombo.validate(async (valid) => {
        if (valid) {
          let data = null;
          if (this.formCombo.id) {
            data = await this.$axios.put("/api/v1/manage/chartered", { ...this.formCombo, organizationId: this.mixinUserInfo.organizationId });
          } else {
            data = await this.$axios.post("/api/v1/manage/chartered", { ...this.formCombo, organizationId: this.mixinUserInfo.organizationId });
          }
          if (data && data.code === 1) {
            this.$message.success('已保存')
            this.getComboList();
            this.comboVisible = false;
          }
        }
      })
    },
    editComboClick(row) {
      this.comboTitle = "编辑包车套餐";
      this.comboVisible = true;
      this.$nextTick(() => {
        this.formCombo = { ...row };
      })
    },
    deleteCombo(id) {
      this.$confirm("删除后乘客端将看不到该套餐，确定删除吗？", "删除提示").then(async () => {
        let data = await this.$axios.delete("/api/v1/manage/chartered", { id });
        if (data && data.code === 1) {
          this.getComboList();
          this.$message.success("删除成功");
        }
      });
    },
    async getCommission() {
      let data = await this.$axios.get("/api/v1/manage/chartered/commission", { organizationId: this.mixinUserInfo.organizationId });
      if (data && data.code === 1) {
        this.commission = data.data;
      }
      this.commissionEdit = false;
    },
    async savecommission() {
      if (this.commission.status == 1 && !this.commission.proportion) {
        this.$message.info("请输入正确的比例");
        return;
      }
      let data = await this.$axios.post("/api/v1/manage/chartered/commission", { ...this.commission, organizationId: this.mixinUserInfo.organizationId });
      if (data && data.code === 1) {
        this.$message.success("已保存");
        this.getCommission();
      }
      this.commissionEdit = false;
    },

    async getIntercityCommissionList() {
      const res = await this.$axios.get("/api/v1/manage/intercity/commission/config", { page: 1, size: 100 });
      if (res && res.code === 1) {
        this.intercityCommissionList = res.data || [];
      }
    },
    editIntercityCommission(row) {
      this.formIntercityCommission = { ...row };
      this.intercityCommissionVisible = true;
    },
    async deleteIntercityCommission(id) {
      this.$confirm("确定删除该提成规则吗？", "删除提示").then(async () => {
        const res = await this.$axios.delete("/api/v1/manage/intercity/commission/config", { id, appKey: this.mixinUserInfo.appKey });
        if (res && res.code === 1) {
          this.$message.success("删除成功");
          this.getIntercityCommissionList();
        }
      });
    },
    async saveIntercityCommission() {
      this.$refs.formIntercityCommission.validate(async (valid) => {
        if (!valid) return;
        this.loadingIntercity = true;
        try {
          const form = { ...this.formIntercityCommission, appKey: this.mixinUserInfo.appKey };
          let res;
          if (form.id) {
            res = await this.$axios.put("/api/v1/manage/intercity/commission/config", form);
          } else {
            res = await this.$axios.post("/api/v1/manage/intercity/commission/config", form);
          }
          if (res && res.code === 1) {
            this.$message.success("保存成功");
            this.intercityCommissionVisible = false;
            this.getIntercityCommissionList();
          }
        } finally {
          this.loadingIntercity = false;
        }
      });
    },
    resetIntercityForm() {
      this.formIntercityCommission = { id: null, name: null, type: 1, proportion: null, status: 1 };
      this.$refs.formIntercityCommission && this.$refs.formIntercityCommission.resetFields();
    },
  },
};
</script>

<style lang="less">
#charteredSetting {
  height: 100%;
  overflow-y: auto;

  .block {
    display: flex;
    flex-wrap: wrap;
    margin-bottom: 20px;

    &__left {
      font-weight: bold;
      width: 100px;
    }

    &__right {
      flex-grow: 1;
    }
  }

  .tips {
    font-size: 14px;
    color: #999;
  }

  .el-tag {
    margin: 0 10px 5px 0;
  }

  .el-input-group__append {
    padding: 0 10px;
  }

  .setting-tabs {
    margin-bottom: 20px;

    .el-tabs__header {
      margin-bottom: 0;
    }
  }
}
</style>
